// extracted by mini-css-extract-plugin
module.exports = {"container":"BackToTop_container__lpvTD"};